import { RequestData } from '@ant-design/pro-table';
import { trpc } from '@tencent/tpro_rmonitor_product_manager_product';
import { BusiCode } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import {
  IAllowCreateReq,
  IAllowCreateRsp,
  IApply,
  IApplyProductReq,
  IApplyProductRsp,
  IGetApplicationReq,
  IGetApplicationRsp,
  IGetApplyDedailReq,
  IGetApplyDedailRsp,
  IGetApprovalReq,
  IGetApprovalRsp,
  IGetBuglyqqProductsReq,
  IGetBuglyqqProductsRsp,
  IGetProductInfoReq,
  IGetProductInfoRsp,
  IGetProductInfosReq,
  IGetProductInfosRsp,
  IProductDetailInfo,
} from '@/proto/manage';
import { TrpcService } from '@/service/trpc';
import { RecursiveNonNullable } from '@raft/utils';
import IDeleteProductReq = trpc.rmonitor.product_manager.IDeleteProductReq;
import IDeleteProductRsp = trpc.rmonitor.product_manager.IDeleteProductRsp;

export class ProductService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.ProductService,
    });
  }

  /**
   * 申请创建产品
   */
  public async applyProduct(req: IApplyProductReq): Promise<IApplyProductRsp> {
    try {
      return  await this.trpcPost<IApplyProductRsp>('ApplyProduct', req);
    } catch (e) {
      return {};
    }
  }

  /**
   * 获取产品详情
   * @param req
   */
  public async getProductInfo(req: IGetProductInfoReq, config?: any): Promise<IProductDetailInfo> {
    try {
      const res = await this.trpcPost<IGetProductInfoRsp>('GetProductInfo', req, config);
      return res?.productInfo || {};
    } catch (e) {
      return {};
    }
  };


  /**
   * 检查是否可以申请产品
   */
  public async allowCreate(req: IAllowCreateReq): Promise<IAllowCreateRsp> {
    try {
      return await this.trpcPost<IAllowCreateRsp>('AllowCreate', req);
    } catch (e) {
      return {};
    }
  };

  /**
   * 拉取用户发起的【产品创建】申请列表
   * @param req
   */
  public async getApplication(req: IGetApplicationReq): Promise<RequestData<IApply>> {
    try {
      const res = await this.trpcPost<IGetApplicationRsp>('GetApplication', req);
      return {
        data: Array.isArray(res.applications) ? res.applications : [],
        success: true,
        total: res.total ?? 0,
      };
    } catch (e) {
      return {
        data: [],
        success: true,
        total: 0,
      };
    }
  };


  /**
   * 拉取超管才能查看的【产品创建】审批列表
   * @param req
   */
  public async getApproval(req: IGetApprovalReq): Promise<RequestData<IApply>> {
    try {
      const res = await this.trpcPost<IGetApprovalRsp>('GetApproval', req);
      return {
        data: Array.isArray(res.approvals) ? res.approvals : [],
        success: true,
        total: res.total ?? 0,
      };
    } catch (e) {
      return {
        data: [],
        success: true,
        total: 0,
      };
    }
  };


  /**
   * 获取申请详情
   * @param req
   */
  public async getApplyDetail(req: IGetApplyDedailReq): Promise<IApply> {
    try {
      const res = await this.trpcPost<IGetApplyDedailRsp>('GetApplyDedail', req);
      if (res.baseRsp?.code !== BusiCode.Ok) {
        return {};
      }
      return res?.apply || {};
    } catch (e) {
      return {};
    }
  };

  public async deleteProduct(req: IDeleteProductReq): Promise<IDeleteProductRsp> {
    try {
      const res = await this.trpcPost('DeleteProduct', req);
      return res;
    } catch (e) {
      return {};
    }
  }


  /**
   * 根据bulgyid到qq上查询其负责的产品列表
   * @param req
   */
  public async getBuglyqqProducts(req: IGetBuglyqqProductsReq): Promise<IProductDetailInfo[]> {
    try {
      const res = await this.trpcPost<IGetBuglyqqProductsRsp>('GetBuglyqqProducts', req);
      return Array.isArray(res.productInfos) ? res.productInfos : [];
    } catch (e) {
      return [];
    }
  };

  /**
   * 超管才能的批量获取产品信息
   * @param req
   */
  public async getProductInfos(req: IGetProductInfosReq): Promise<RecursiveNonNullable<IProductDetailInfo>[]> {
    try {
      const res = await this.trpcPost<RecursiveNonNullable<IGetProductInfosRsp>>('GetProductInfos', req);
      return Array.isArray(res.productInfos) ? res.productInfos : [];
    } catch (e) {
      return [];
    }
  };
}


export const productService = new ProductService();
